module.exports = __webpack_public_path__ + "static/img/dingimg.46e3c30.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/dingimg.png
// module id = RjbL
// module chunks = 1